import * as React from "react";
import ConfirmationModal from './ConfirmationModal';

const FormInput = ({ label, type = "text", id, value, onChange, disabled }) => {
  return (
    <div className="tw-flex tw-flex-col tw-self-stretch tw-my-auto tw-min-w-[240px] tw-w-full">
      <div className="tw-flex tw-flex-col tw-justify-center tw-items-start tw-px-8 tw-py-6 tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-captures md:tw-px-5">
        <label htmlFor={id} className="tw-sr-only">{label}</label>
        <input
          type={type}
          id={id}
          placeholder={label}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className="tw-w-full tw-font-medium tw-bg-transparent tw-outline-none tw-border-none"
          aria-label={label}
        />
      </div>
    </div>
  );
};

const CategorySelect = ({ value, onChange, disabled }) => {
  return (
    <div className="tw-flex tw-flex-col tw-self-stretch tw-my-auto tw-w-full">
      <div className="tw-flex tw-gap-5 tw-justify-between tw-px-7 tw-py-6 tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-captures md:tw-px-5">
        <label htmlFor="category" className="tw-sr-only">Product Category</label>
        <select
          id="category"
          className={`${value == '' ? 'tw-text-black tw-text-opacity-25' : ''} tw-w-full tw-bg-transparent tw-font-medium tw-outline-none tw-border-none`}
          aria-label="Product Category"
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          <option value="">Product Category</option>
          <option value="Apparel">Apparel</option>
          <option value="Blankets">Blankets</option>
          <option value="Books">Books</option>
          <option value="Coffee & Tea">Coffee & Tea</option>
          <option value="Decor">Decor</option>
          <option value="Fitness">Fitness</option>
          <option value="Furniture">Furniture</option>
          <option value="Holiday/Gifts">Holiday/Gifts</option>
          <option value="Home">Home</option>
          <option value="Kitchen">Kitchen</option>
          <option value="Leather Goods">Leather Goods</option>
          <option value="Outdoor">Outdoor</option>
          <option value="Pets">Pets</option>
          <option value="Shoes">Shoes</option>
          <option value="Socks">Socks</option>
          <option value="Tech">Tech</option>
          <option value="Toys">Toys</option>
        </select>
      </div>
    </div>
  );
};

export default function RequestToSell() {
  const [formData, setFormData] = React.useState({
    firstname: "",
    lastname: "",
    email: "",
    '0-2/name': "",
    product_category: "",
    website: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);
      setError("");

      const formDataObj = new FormData();
      formDataObj.append('firstname', formData.firstname);
      formDataObj.append('lastname', formData.lastname);
      formDataObj.append('email', formData.email);
      formDataObj.append('business_name', formData['0-2/name']);
      formDataObj.append('product_category', formData.product_category);
      const website = formData.website && !/^https?:\/\//i.test(formData.website)
        ? `https://${formData.website}`
        : formData.website;
      formDataObj.append('website', website);
      formDataObj.append('message', formData.message);

      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      const response = await fetch('/submit_demo_request', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        body: formDataObj
      });

      if (response.ok) {
        setFormData({
          firstname: "",
          lastname: "",
          email: "",
          '0-2/name': "",
          product_category: "",
          website: "",
          message: ""
        });
        setShowModal(true);
      } else {
        setError('There was an error submitting your request. Please try again.');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('There was an error submitting your request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="tw-flex tw-relative tw-flex-col tw-px-4 md:tw-px-20 tw-py-20 md:tw-py-32 tw-w-full"
        style={{ background: '#E6EBE9' }}>
        <img
          loading="lazy"
          src="https://expertpeople.imgix.net/assets/images/forbrands-background-pattern.svg"
          alt=""
          className="tw-absolute tw-inset-0 tw-w-full tw-h-full"
        />
        <h1 className="tw-relative tw-self-start tw-text-5xl md:tw-text-6xl tw-leading-tight tw-text-neutral-800">
          Request a Solvy Demo
        </h1>

        <form onSubmit={handleSubmit}>
          <div className="tw-flex tw-flex-col md:tw-flex-row tw-relative tw-gap-8 tw-items-center tw-mt-10 tw-font-medium tw-text-neutral-800 md:tw-mr-0.5 md:tw-max-w-full">
            <FormInput label="First Name" id="firstName" value={formData.firstname} onChange={(e) => setFormData({ ...formData, firstname: e.target.value })} disabled={isSubmitting} />
            <FormInput label="Last name" id="lastName" value={formData.lastname} onChange={(e) => setFormData({ ...formData, lastname: e.target.value })} disabled={isSubmitting} />
            <FormInput label="Email" type="email" id="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} disabled={isSubmitting} />
          </div>

          <div className="tw-flex tw-flex-col md:tw-flex-row tw-relative tw-gap-8 tw-items-center tw-mt-8 tw-font-medium tw-text-neutral-800 md:tw-mr-0.5 md:tw-max-w-full">
            <FormInput label="Business name" id="businessName" value={formData['0-2/name']} onChange={(e) => setFormData({ ...formData, '0-2/name': e.target.value })} disabled={isSubmitting} />
            <CategorySelect value={formData.product_category} onChange={(e) => setFormData({ ...formData, product_category: e.target.value })} disabled={isSubmitting} />
            <FormInput label="Website" id="website" value={formData.website} onChange={(e) => setFormData({ ...formData, website: e.target.value })} disabled={isSubmitting} />
          </div>

          <div className="tw-flex tw-relative tw-items-start tw-px-8 tw-pt-8 tw-pb-28 tw-mt-8 tw-font-medium tw-bg-white tw-rounded-lg tw-border tw-border-solid tw-border-captures tw-text-neutral-800 md:tw-px-5 md:tw-pb-24 md:tw-mr-0.5 md:tw-max-w-full">
            <label htmlFor="message" className="tw-sr-only">Message</label>
            <textarea
              id="message"
              className="tw-w-full tw-bg-transparent tw-font-medium tw-outline-none tw-border-none"
              placeholder="Message"
              aria-label="Message"
              rows={4}
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              disabled={isSubmitting}
            />
          </div>

          {error && (
            <div role="alert" className="tw-relative tw-mt-4 tw-text-red-600 tw-font-medium">
              {error}
            </div>
          )}

          <div className="tw-flex tw-flex-col md:tw-flex-row tw-relative tw-gap-10 tw-self-center md:tw-self-end tw-mt-12 tw-mb-0 tw-max-w-full tw-text-lg tw-text-center" style={{ maxWidth: "717px" }}>
            <div className="tw-flex-auto tw-my-auto tw-font-medium tw-opacity-40 tw-text-neutral-800">
              By submitting you agree to our Privacy Policy
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="tw-self-center md:tw-self-start tw-grow tw-px-16 tw-py-5 tw-font-extrabold tw-text-white tw-uppercase tw-whitespace-nowrap tw-rounded-lg tw-bg-dark-green tw-tracking-[4.32px] tw-w-80 md:tw-px-5 tw-border-0 tw-cursor-pointer disabled:tw-opacity-70 disabled:tw-cursor-not-allowed"
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>

      <ConfirmationModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="Demo Request Sent!"
        message="Thank you for your interest in Solvy! We've received your demo request and our team will get back to you shortly."
      />
    </>
  );
};

